import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingStockCountListView from 'src/sections/packaging-stock-count/view/packaging-stock-count-list-view';

export default function PackagingStockCountListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Packaging Stock Counts</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingStockCountListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
